// extracted by mini-css-extract-plugin
export default {"emptyStateDivBox":"emptyStateDivBox__A98Rt"};